


















































/* eslint-disable @typescript-eslint/no-empty-function */
import {
  Component, Vue, Watch, Prop,
} from "vue-property-decorator";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

@Component({ components: { flatPickr } })
export default class EntityField extends Vue {
  // Input option 1: field object from entity description
  @Prop() field?: any;

  // Input option 2: full entity description and field key
  @Prop() entityDescription?: any[];

  @Prop() fieldKey?: string;

  @Prop() entity: any;

  @Prop({ default: false })
  readOnly!: boolean;

  @Prop({ default: () => { } })
  errors!: { [key: string]: string};

  flatPickrConfig = {
    enableTime: true,
    dateFormat: "Z",
    altInput: true,
    altFormat: "d/m/Y H:i",
  };

  get error() {
    return this.errors && this.errors[this.fieldDefinition.key];
  }

  get fieldDefinition() {
    if (this.field) {
      return this.field;
    }
    if (this.entityDescription && this.fieldKey) {
      return this.entityDescription.find((field) => field.key === this.fieldKey);
    }
    return {};
  }

  async mounted() {
    if (this.field?.kind === "relation") {
      await this.loadManyToOneOptions(this.field);
    }
  }

  async loadManyToOneOptions(field: any) {
    if (this.fieldDefinition.model) {
      const searchOptions: any = {};
      const manyToOneModelDescription = await this.fieldDefinition.model.getDescription();
      if (manyToOneModelDescription.find((field: any) => this.fieldDefinition.key === 'name')) {
        searchOptions.sort = [{ field: 'name', order: 'ASC' }];
      }
      this.fieldDefinition.manyToOneOptions = await this.fieldDefinition.model.search(searchOptions, null, this.fieldDefinition.key);
    }
  }

  uploadCompleted(event: any, fieldKey: string) {
    this.$vs.loading.close();
    this.$vs.notification({ color: "success", title: "Sucesso", text: "O arquivo foi enviado" });
    const response = JSON.parse(event.target?.response);
    this.entity[fieldKey] = response.uuid;
  }

  uploadError(event: any) {
    this.$vs.loading.close();
    console.error("Upload error", event);
    this.$vs.notification({ color: "danger", title: "Erro", text: "Ocorreu um erro ao enviar o arquivo" });
  }

  openFile(fileUrl: string) {
    window.open(fileUrl, "_blank");
  }

  fileChanged() {
    this.$vs.loading();
  }
}
